import { IViolation } from '../base/annotation';
import { ActionConstants } from '../../constants/action-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { A365Named } from '../base/a365Named';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { SharedModel } from '../sharedmodel';

@Metamodel.model({
    name: ModelConstants.linkTable,
    display: [shellStringResources.LinkTable],
    reusable: true,
    referable: true,
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.linkConnectionsWrite
        },
        deleteResource: {
            action: ActionConstants.linkConnectionsDelete
        }
    }
})
export class LinkTable extends A365Named {
    public sourceTableName: string;
    public sourceSchemaName: string;
    @Metamodel.attribute({
        constraint: {
            validator: LinkTable._schemaTableNameValidator
        }
    })
    public targetTableName: string;
    @Metamodel.attribute({
        constraint: {
            validator: LinkTable._schemaTableNameValidator
        }
    })
    public targetSchemaName: string;
    public distributionType: string;
    public distributionColumn?: string;
    public partitionColumns?: string[];
    public structureOptionType?: SharedModel.TableStructureType;

    private static _schemaTableNameValidator(owner: LinkTable, name: string): IViolation[] {
        if (!name || name.length < 1 || name.length > 128 || name.includes('[') || name.includes(']')) {
            return [
                {
                    message: () => shellStringResources.LinkTableNameValidationError
                }
            ];
        }
        return undefined;
    }

}
